import React from "react";
import LoginLayout from 'layout/LoginLayout'

import { Link,  withRouter } from 'react-router-dom';

// import zxcvbn from 'zxcvbn';

import { authenticationService } from 'auth/authenticationService.js'
import LockOpenIcon from '@mui/icons-material/LockOpen';


import {  Typography,
          TextField,
          Button,
          Box, CircularProgress
        } from '@mui/material'

class Login extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      username: '',
      password: '',
      errorlogin:false,
      loginfeedback:false,
      loginloading:false,
    };

    this.handleLoad = this.handleLoad.bind(this);
    this.handleLogin = this.handleLogin.bind(this);


  }


  handleLoad(token){
  }
  componentDidMount(){
    this.handleLoad();
    console.log(this.props);
  }

  handleLogin(event){
    this.setState({loginloading:true});
    event.preventDefault();
    authenticationService.login({
        username: this.state.username.toLowerCase(),
        password: this.state.password
    })
    .then( (response) => {

      if(response){
        let ok = true;
        // First login caso

        if(typeof(response.person_object) !== 'undefined' && 'person_object' in response && response.person_object !== null){
          console.log(1);
          if(typeof(response.person_object.company_object) !== 'undefined' && 'company_object' in response.person_object && response.person_object.company_object !== null){
            console.log(2);
            console.log(response)
            if(response.person_object.first_signin === true){
              console.log(3);
              this.props.history.push('/company_first_login');
              ok = false;
            }
          }
        }
        if(ok){
          this.setState({loginerror:false, loginloading:false});

          if('state' in this.props.location){
            if(typeof(this.props.location.state) !== 'undefined'){
              if('from' in this.props.location.state){
                if(this.props.location.state.from.pathname === '/dashboard/'){
                  this.props.history.push('/dashboard/');
                }
                else{
                  this.props.history.push(this.props.location.state.from.pathname);
                }
              }
              else{
                this.props.history.push('/dashboard/');
              }
            }
            else{
              this.props.history.push('/dashboard/');
            }
          }
          else{
            this.props.history.push('/dashboard/');
          }
        }
      }
      else{
        this.setState({loginfeedback:'Usuario o contraseña inválidos'});
        this.setState({loginerror:true});
        this.setState({loginloading:false});
      }
    });
  }

  render() {
    return (
    <LoginLayout>

      <Typography variant='h5'>Bienvenido</Typography>
      <form onSubmit={this.handleLogin}>
        <Box p={1}>
          <TextField  label='Email'
                      id="username"
                      name="username"
                      value={this.state.username}
                      error={this.state.loginerror}
                      fullWidth
                      onChange={e => this.setState({username:e.target.value})}
          />
        </Box>
        <Box p={1}>
          <TextField  label='Contraseña'
                      type="password"
                      name="password"
                      className='form-control'
                      value={this.state.password}
                      error={this.state.loginerror}
                      helperText={this.state.loginfeedback}
                      fullWidth
                      onChange={e => this.setState({password:e.target.value})}
          />
        </Box>
        <br/>
        <Box p={1}>
          <Button color='primary'
                  type="submit"
                  onClick={this.handleLogin}
                  variant="contained"
                  startIcon={this.state.loginloading?<CircularProgress size={20}/>:<LockOpenIcon />}
                  disabled={this.state.loginloading?true:false}
                  >
            Entrar al sitio
          </Button>
        </Box>
      </form>

      <br/>
      <Box p={1} align='left'>
        <Button component={Link} to='password_recovery/' color='primary'>Recuperar contraseña</Button>
      </Box>
    </LoginLayout>
    );
  }
}

export default withRouter(Login);
